export default __webpack_public_path__ + "static/media/search.39b4f267.svg";